module.exports = __webpack_public_path__ + "static/economics-in-one-lesson-eef68b949cfa8fde766237d67c7ccdd5.jpg";